import { Link } from "react-router-dom";
import { Infinity as InfinityIcon } from "lucide-react";

const SIZES = {
  sm: { icon: "w-5 h-5", text: "text-lg" },
  md: { icon: "w-6 h-6", text: "text-xl" },
};

/** The Unbound wordmark. Used in the app shell and on every public page. */
export const Logo = ({ to = "/", size = "sm", testId = "unbound-logo" }) => {
  const s = SIZES[size] || SIZES.sm;
  const inner = (
    <>
      <InfinityIcon className={`${s.icon} text-blue-600`} />
      <span className={`font-display font-extrabold ${s.text} tracking-tight`}>Unbound</span>
    </>
  );
  if (!to) {
    return (
      <span className="flex items-center gap-2" data-testid={testId}>
        {inner}
      </span>
    );
  }
  return (
    <Link to={to} className="flex items-center gap-2 hover:opacity-80 transition-opacity" data-testid={testId}>
      {inner}
    </Link>
  );
};
